// import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';

export const selectMessages = (state:RootState) => state[Reducers.Messages].messages;
export const selectLoading = (state:RootState) => state[Reducers.Messages].loading;
